import React, {ReactNode} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'

type Props = {
  className?: string
  footer?: ReactNode
  header: string
  height?: string
  id: any
  isOpen: boolean
  modalBodyClassName?: string
  onClose: (val: boolean) => void
  maxWidth?: string
}

export const AncientModal: React.FC<Props> = ({
  children,
  className,
  footer,
  header,
  height,
  id,
  isOpen,
  modalBodyClassName,
  onClose,
  maxWidth,
}) => {
  const onModalClose = () => {
    onClose(false)
  }

  return (
    <>
      {isOpen && (
        <>
          <div
            className='modal fade show d-block'
            id={id}
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            <div className={`modal-dialog ${className}`} style={{maxWidth}}>
              <div className='modal-content' style={{height}}>
                <div className='modal-header'>
                  <h2 className='fw-bolder'>{header}</h2>

                  <div
                    className='btn btn-icon btn-sm btn-active-icon-primary'
                    data-kt-users-modal-action='close'
                    onClick={onModalClose}
                    style={{cursor: 'pointer'}}
                  >
                    <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
                  </div>
                </div>
                <div className={`modal-body scroll-y mx-5 mx-xl-15 my-7 ${modalBodyClassName}`}>
                  {children}
                </div>
                {footer && footer}
              </div>
            </div>
          </div>
          <div className='modal-backdrop fade show'></div>
        </>
      )}
    </>
  )
}
